import http from '@/assets/api/http';

export default {
    image: {
        getToken: () => http('/?cmd=com.xqxc.api.pig.mis.biz.platform.QiniuUploadTokenMisService.qiNiuImgToken'),
        getFile: ({ key }) => http('/?cmd=com.xqxc.api.pig.mis.biz.platform.QiniuUploadTokenMisService.qiNiuGetUrl', { param: key }),
    },
    file: {
        getToken: ({ fileName }) => http('/qiniu/uploadVideoToken'),
        getFile: ({ fileName, key }) => http('/qiniu/getUrlAudioVideo/', { fileName: key })
    }
};